import {LuRuler, TfiLayersAlt, FiAirplay,LuTag, LuPen, LuBriefcase} from '../assets/icons/vander'

export const feature = [
    {
        icon:LuRuler,
        title:'Fresh Layouts',
        desc:"The most well-known dummy text is the 'Lorem', distribution letters which is said to have in."
    },
    {
        icon:TfiLayersAlt,
        title:'Fresh Layouts',
        desc:"The most well-known dummy text is the 'Lorem', distribution letters which is said to have in."
    },
    {
        icon:FiAirplay,
        title:'Fully Responsive',
        desc:"One disadvantage of Lorum Ipsum is that in certain distribution letters letters appear more than."
    },
]


export const pricingOne = [
    {
        icon:LuTag,
        iconClass:'h2 text-warning',
        title:'Starter',
        value:'9',
        feature:['Full Access','Source Files','Free Appointments','Enhanced Security']
    },
    {
        icon:LuPen,
        iconClass:'h2 text-danger',
        title:'Business',
        value:'39',
        feature:['Full Access','Source Files','Free Appointments','Enhanced Security','6 Month Support']
    },
    {
        icon:LuBriefcase,
        iconClass:'h2 text-info',
        title:'Premium',
        value:'99',
        feature:['Full Access','Source Files','Free Appointments','Enhanced Security','6 Month Support','Free Images']
    },
]